import { render, staticRenderFns } from "./PaginationGoTo.vue?vue&type=template&id=68b082de&"
import script from "./PaginationGoTo.vue?vue&type=script&lang=js&"
export * from "./PaginationGoTo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports